import { useMutation } from '@tanstack/react-query';
import axios from '../../../sharedModules/utils/axios.utils';

interface SendOneOffEmailArgs {
  clientId: number;
  toEmail: string;
  subject: string;
  body: string;
  attachments: File[];
  invoicePdfIds: number[];
}

const sendOneOffEmail = async ({
  clientId,
  toEmail,
  subject,
  body,
  attachments,
  invoicePdfIds,
}: SendOneOffEmailArgs) => {
  const formData = new FormData();
  formData.append('to_email', toEmail);
  formData.append('subject', subject);
  formData.append('body', body);
  attachments.forEach((file) => formData.append('attachments[]', file));
  invoicePdfIds.forEach((id) => formData.append('invoice_pdf_ids[]', String(id)));

  return axios.post(`/collections/clients/${clientId}/one_off_emails`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const useSendOneOffEmail = () => {
  const mutation = useMutation({ mutationFn: sendOneOffEmail });

  return {
    sendOneOffEmail: mutation.mutateAsync,
    isLoading: mutation.isPending,
  };
};
